import React from "react";
import {IProps} from "../types/homePageTypes";

const PropsContext = React.createContext<IProps | undefined>(undefined);

export const PropsProvider = PropsContext.Provider;
export const PropsConsumer = PropsContext.Consumer;